import { render, staticRenderFns } from "./OrderRelease.vue?vue&type=template&id=6bd7a9e5&scoped=true&"
import script from "./OrderRelease.vue?vue&type=script&lang=js&"
export * from "./OrderRelease.vue?vue&type=script&lang=js&"
import style0 from "./OrderRelease.vue?vue&type=style&index=0&id=6bd7a9e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd7a9e5",
  null
  
)

export default component.exports